import { jwtDecode } from "jwt-decode";

const CheckToken = (shouldRedirect = true) => {
  const token = localStorage.getItem("token");
  if (!token) {
    if (shouldRedirect) window.location.href = "/";
    return { isValid: false };
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const isValid = decoded.exp > currentTime;

    if (!isValid && shouldRedirect) {
      window.location.href = "/";
    }

    return { isValid, decoded };
  } catch (error) {
    if (shouldRedirect) window.location.href = "/";
    return { isValid: false };
  }
};

export default CheckToken;
